import { Component, Input } from '@angular/core';
import { ApexAxisChartSeries, ApexChart, ApexDataLabels, ApexYAxis, ApexLegend, ApexStroke, ApexXAxis, ApexTooltip, ApexTitleSubtitle } from "ng-apexcharts";
import { Helper } from '../../utilities/classes/helper.class';

@Component({
  selector: 'app-acc-splinechart',
  templateUrl: './acc-splinechart.component.html',
  styleUrls: ['./acc-splinechart.component.scss']
})
export class AccSplinechartComponent {

  @Input('properties') public properties: SplineChartOptions = this.defaultSplineChartOptions();
  constructor() { }

  public defaultSplineChartOptions(): SplineChartOptions {
    return Helper.chartOptions.spline;
  }

}



export type SplineChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  stroke: ApexStroke;
  tooltip: ApexTooltip;
  dataLabels: ApexDataLabels;
  yaxis: ApexYAxis;
  legend: ApexLegend;
  title: ApexTitleSubtitle;
  colors: string[];
};
